import {baseGetRowsRequest} from "../base/baseGetRowsRequest";
import {NestedPolicyType} from "../policy/types";

const getNestedPolicies = async <PolicyType extends NestedPolicyType>(
  id_link: number,
  resource: "project" | "profile"
) => baseGetRowsRequest<PolicyType>(`/${resource}/${id_link}/policy/`);

export default getNestedPolicies;
